import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Footer from './containers/Footer/Footer';
import Navbar from './containers/Header/Navbar';
import Home from './Home';
import Booking from './Pages/Booking';
import Projects from './Pages/Projects';
function App() {
  return (
    <BrowserRouter>
      <div className="App bg-babypowder dark:bg-black">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/projects" element={<Projects />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}
export default App;
